import PropTypes from 'prop-types';
import React from 'react';

import './Errors.css';

function Errors(_ref) {
  var errors = _ref.errors;

  if (errors.length === 0) {
    return React.createElement('div', null);
  }

  return React.createElement(
    'div',
    { className: 'Errors' },
    React.createElement('hr', null),
    React.createElement(
      'h3',
      null,
      'Please resolve these errors before submitting'
    ),
    React.createElement(
      'ul',
      null,
      errors.map(function (e) {
        return React.createElement(
          'li',
          { key: e.name },
          e.message
        );
      })
    )
  );
}

Errors.propTypes = process.env.NODE_ENV !== "production" ? {
  errors: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
} : {};

export default Errors;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/Errors.js
// module id = 694
// module chunks = 0